import { Pipe, PipeTransform } from '@angular/core';
import { CapacityReportStatus } from '@libs/services/graphql/generated/ala-backend.service';

@Pipe({
  name: 'alaEnumReverseMapping',
  standalone: true,
})
export class EnumReverseMappingPipe implements PipeTransform {
  public transform(val: CapacityReportStatus): string {
    switch (val) {
      case CapacityReportStatus.NOTSTARTED:
        return 'Not started';
      case CapacityReportStatus.COMPLETED:
        return 'Completed';
      case CapacityReportStatus.INPROGRESS:
        return 'In progress';
      default:
        return 'Unknown';
    }
  }
}
